<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>服务类目
    </div>
    <div class="content contentBody"
         v-loading="refreshOption"
         element-loading-text="努力刷新中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.4)"
    >
      <div class="SettingCate-title">
        <div class="SettingCate-l">
          <span>服务类目</span>
          已添加{{this.tableData.length}}个，最多5个
        </div>
        <div class="SettingCate-r">
          本月可添加{{cateInfo?cateInfo.quota:0}}次
          <el-button type="success" class="settingBtn-cate" @click="addCateFn">添加类目</el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="服务名称" align="center">
            <template slot-scope="scope">
              {{scope.row.first_name+' -> '+scope.row.second_name}}
            </template>
          </el-table-column>
          <el-table-column label="所有状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.audit_status==1" class="cate-loading">审核中</span>
              <span v-if="scope.row.audit_status==2" class="cate-fail">审核不通过</span>
              <span v-if="scope.row.audit_status==3" class="cate-success">审核通过</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span class="cate-fail detelCateClass" @click="detelCateFn(scope.$index)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
              title="添加服务类目"
              :visible.sync="dialogVisible"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :before-close="beforeCloseFn"
              width="50%">
        <div class="selectCateList">
          <div class="selectCateList-line" v-for="(item,indexs) in addData" :key="indexs">
            <div class="selectCateList-line-select">
              <span class="selectCateList-line-name">服务类目</span>
              <el-select v-model="disabledStatus[indexs].name" placeholder="请选择" class="seletCateCheck"
                         @change="selectValueFn">
                <el-option
                        v-for="(item,index) in options"
                        :key="item.id"
                        :label="item.name"
                        :value="indexs+'-'+index">
                </el-option>
              </el-select>
              <el-select v-model="disabledStatus[indexs].name1" placeholder="请选择" class="seletCateCheck"
                         @change="selectValueTwoFn"
                         :disabled="disabledStatus[indexs].disabled">
                <el-option
                        v-for="(item,index) in options1"
                        :key="item.id"
                        :label="item.name"
                        :value="indexs+'-'+index">
                </el-option>
              </el-select>
              <div class="icon-add">
                <i class="el-icon-circle-plus" @click="addCateList(1,indexs)" v-if="addData.length<3"></i>
                <i class="el-icon-remove" @click="addCateList(2,indexs)" v-if="addData.length!==1"></i>
              </div>
            </div>
            <div class="erro-list-line">
              <span class="cateline-box-line-name"></span>
              <div class="erro-text" v-if="disabledStatus[indexs].erro">
                <p>不能添加相同服务类目</p>
              </div>
            </div>
            <div v-for="(items,indexline) in item.certicates" class="cateline-box-line" :key="indexline">
              <span class="cateline-box-line-name">{{items.key}}</span>
              <div class="cateline-box-line-img">
                <p class="title-text">上传原件或复印件，复印件务必加盖公司公章
                  文件格式为jpg、jpeg、bmp、gif或png，文件大小不超过10M，1M以内不压缩，1M以上将压缩至20%大小。</p>
                <el-upload
                        :action="ImgUrl_"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        :data="upload_data"
                >
                  <el-button size="mini" @click="saveImgIndex(indexs, indexline)">选择资质图片素材</el-button>
                </el-upload>
                <p v-if="items.value" class="uploadSuccess">上传成功</p>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="beforeCloseFn">取消</el-button>
          <el-button type="primary" @click="submitCloseFn">提交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "miniappPannel",
    data() {
      return {
        ImgUrl_: api.upload_media,
        refreshOption: false,
        // 裁剪
        tableData: [],
        dialogVisible: false,
        // select
        options: [],
        options1: [],
        addData: [
          {'first': '', 'second': '', 'certicates': []}
        ],
        disabledStatus: [{name: '', name1: '', disabled: false, erro: false}],
        uploadImg: [0, 0],
        upload_data: {token: sessionStorage.getItem("token")},
        cateInfo: null
      };
    },
    created() {
      this.InitFn();
      this.CateInitFn();
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.company_authorization, {})
            .then(response => {
              if (response.data.code == 0) {
                if (response.data.info.service_cate === '[]') {
                  response.data.info.service_cate = [];
                };
                this.cateInfo =  response.data.info;
                this.tableData = response.data.info.service_cate;
              } else {
              }
            })
            .catch(response => {
            });
      },
      CateInitFn() {
        this.axios
            .post(api.company_getallcategories, {})
            .then(response => {
              if (response.data.code == 0) {
                this.options = response.data.list
              } else {
              }
            })
            .catch(response => {
            });
      },
      selectValueFn(selVal) {
        let index_ = selVal.split('-'); //0 列序列号 1 首项类目
        this.disabledStatus[index_[0]].name = this.options[index_[1]].name;
        this.value1 = '';
        this.options1 = this.options[index_[1]].children;
        this.addData[index_[0]].first = this.options[index_[1]].id;
        if (!this.options[index_[1]].children.length) {
          this.disabledStatus[index_[0]] = true
        }
        if (this.options[index_[1]].children.length === 0 && this.options[index_[1]].sensitive_type === 1) {
          let obj_ = [];
          let list_ = this.options[index_[1]].qualify.exter_list;
          for (let i in list_) {
            let arry_ = {};
            arry_.key = list_[i].inner_list[0].name;
            arry_.value = '';
            obj_.push(arry_);
          }
          this.addData[index_[0]].certicates = obj_;
        } else {
          this.addData[index_[0]].certicates = [];
        }
      },
      selectValueTwoFn(selVal) {
        let index_ = selVal.split('-'); //0 列序列号 1 首项类目
        this.disabledStatus[index_[0]].name1 = this.options1[index_[1]].name;
        this.addData[index_[0]].second = this.options1[index_[1]].id;
        // 1 进行上传 资质
        for (let i in this.disabledStatus) {
          this.disabledStatus[i].erro = false;
        }
        let idObj_ = []
        for (let i in this.addData) {
          if (idObj_.indexOf(this.options1[index_[1]].id) !== -1 && this.addData.length > 1) {
            this.disabledStatus[index_[0]].erro = true;
          }
          idObj_.push(this.addData[i].second)
        }
        if (this.options1[index_[1]].sensitive_type === 1) {
          let obj_ = [];
          let list_ = this.options1[index_[1]].qualify.exter_list;
          for (let i in list_) {
            let arry_ = {};
            arry_.key = list_[i].inner_list[0].name;
            arry_.value = '';
            obj_.push(arry_);
          }
          this.addData[index_[0]].certicates = obj_;
        } else {
          this.addData[index_[0]].certicates = [];
        }
      },
      goback() {
        this.$router.go(-1);
      },
      addCateFn() {
        this.dialogVisible = !this.dialogVisible;
      },
      handleAvatarSuccess(res, file) {
        if (res.code === 0) {
          this.addData[this.uploadImg[0]].certicates[this.uploadImg[1]].value = res.media_id;
        } else {
          this.$message.error(res.msg);
        }
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 10MB!");
        }
        return isLt2M;
      },
      addCateList(type, index) {
        // type 1 添加 2 删减
        if (type === 1) {
          this.addData.push({'first': '', 'second': '', 'certicates': []});
          this.disabledStatus.push({name: '', name1: '', disabled: false});
        } else {
          this.addData.splice(index, 1);
          this.disabledStatus.splice(index, 1);
        }
      },
      saveImgIndex(index, index_) {
        this.uploadImg[0] = index;
        this.uploadImg[1] = index_;
      },
      beforeCloseFn() {
        this.dialogVisible = !this.dialogVisible;
        this.addData = [
          {'first': '', 'second': '', 'certicates': []}
        ];
        this.disabledStatus = [{name: '', name1: '', disabled: false, erro: false}];
        this.uploadImg = [0, 0];
      },
      submitCloseFn() {
        let obj = {};
        obj.categories = this.addData;  
        this.axios
            .post(api.company_addcategory, obj)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '提交成功',
                });
                this.dialogVisible = !this.dialogVisible;
                this.addData = [
                  {'first': '', 'second': '', 'certicates': []}
                ];
                this.disabledStatus = [{name: '', name1: '', disabled: false, erro: false}];
                this.uploadImg = [0, 0];
                // 添加成功，刷新服务类目
                this.axios
                  .post(api.company_authorization, {})
                  .then(res => {
                    if (res.data.code == 0) {
                      if (res.data.info.service_cate === '[]') {
                        res.data.info.service_cate = [];
                      };
                      this.tableData = res.data.info.service_cate;
                    }
                  })
                .catch(res => {
                });
              } 
            })
            .catch(response => {
            });
      },
      detelCateFn(index) {
        let _this = this;
        this.$confirm('此操作将永久删除该类目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data_ = {first: _this.tableData[index].first, second: _this.tableData[index].second};
          _this.axios
              .post(api.company_deletecategory, data_)
              .then(response => {
                if (response.data.code == 0) {
                  _this.$message({
                    message: '删除成功!'
                  });
                  _this.tableData.splice(index, 1);
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {
        });
      }
    },
  };
</script>
